import {Injectable} from "@angular/core";
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";
import {EnumOrigemPedido} from "../objeto/EnumOrigemPedido";
import {CellcoinCartaoTokenizacaoService} from "./cellcoin-cartao-tokenizacao.service";

@Injectable({
  providedIn: 'root'
})
export class PedidosService  extends ServerService {

  constructor(http: HttpClient,
              private cellcoinTokenizacao: CellcoinCartaoTokenizacaoService) {
    super(http);
  }

  async salvePedido(dadosPedido: any){
    if(!dadosPedido.origem)
      dadosPedido.origem = EnumOrigemPedido.Loja

    await this.preparePagamentosCartao(dadosPedido);

    if(dadosPedido.guid)
      return   this.salve('/pedidos/' + dadosPedido.guid, dadosPedido)

    return this.salve('/pedidos', dadosPedido)
  }

  tokenizeCartao(card: any, publicKey: string){
    let dadosCartao: any = {
      type: "card",
      card: card
    }

    return new Promise( (resolve, reject) => {
      this.http.post('https://api.pagar.me/core/v5/tokens?appId=' + publicKey, dadosCartao)
        .toPromise().then( (res: any) => {
        resolve(res.id);
      }).catch((fail: any) => {
        let erro = 'Cartão inválido';
        if(fail.error && fail.error.errors && fail.error.errors['request.card'])
          erro += ":" +   fail.error.errors['request.card'][0]

        reject(erro)
      } )
    })

  }

  cancelePedido(pedido: any) {
    return this.http.put('/pedidos/' + pedido.guid + '/cancele/loja', pedido)
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  gereLinkPagamento(pedido: any){
    return this.http.post(String(`/pedidos/${pedido.codigo}/pagamento/online`), {})
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  async tentePagamentoCartao(dadosPedido: any) {
    await this.preparePagamentosCartao(dadosPedido);

    return this.salve(`/pedidos/${dadosPedido.codigo}/cartao/novoPagamento`, dadosPedido)
  }

  tentePagamentoPix(dadosPedido){
    return this.salve('/pedidos/cartao/novoPix', dadosPedido)
  }

  listePedidos(inicio: number, total: number){
    let dados: any = { i: inicio, t: total};

    return this.obtenha('/pedidos/me', dados);
  }

  obtenhaAdicionaisPedido(empresa: any) {
    return this.obtenha('/pedidos/adicionais-pedido?eid=' + empresa.id, {});
  }

  monitorePagamentoOnline(codigo: any){
    return this.obtenha('/pedidos/monitoramento/' + codigo, { })
  }


  obtenhaPorGuid(codigo: any, idEmpresa: any = null) {
    return this.obtenha('/pedidos/chave/' + codigo, {  });
  }


  validePedirNovamente(codigo: any) {
    return this.obtenha(String(`/pedidos/${codigo}/valide/pedirnovamente`), {  });
  }

  obtenhaPorCodigo(guid: any , idEmpresa: any = null) {
    return this.obtenha('/pedidos/chave/' + guid, {  });
  }

  configureAdicionaisDoPedido(pedido) {
    for (let item of pedido.itens) {
      item.adicionais = []
      if (item.adicionaisEscolhaSimples && item.adicionaisEscolhaSimples.id) {
        for (let campo in item.adicionaisEscolhaSimples)
          if (campo.startsWith('campo'))
            item.adicionais.push({ opcao: item.adicionaisEscolhaSimples[campo], qtde: 1})

      }
      if(item.adicionaisMultiplaEscolha && item.adicionaisMultiplaEscolha.id) {
        for (let campo in item.adicionaisMultiplaEscolha)
          if (campo.startsWith('lista'))
            for(let valoresOpcao of item.adicionaisMultiplaEscolha[campo].opcoes)
              item.adicionais.push(valoresOpcao)
      }

    }
  }


  async obtenhaComandaDoCartao(mesa: any, conteudoQrCartao: string) {
    return this.facaPost(`/comandas/mesa/${encodeURIComponent(mesa.id)}/cartaocliente`, {
      mesa,
      conteudoQrCartao
    });
  }

  async obtenhaComandaDaMesaDoCartao(tokenCartao: string, conteudoQrMesa: string) {
    return this.facaPost('/comandas/cartao-cliente/mesa', {
      tokenCartao,
      conteudoQrMesa
    });
  }

  async obtenhaComandaDaMesaPeloNome(tokenCartao: string, nomeMesa: string) {
    return this.facaPost('/comandas/cartao-cliente/mesa', {
      tokenCartao,
      nomeMesa
    });
  }

  private async preparePagamentosCartao(dadosPedido: any) {
    const pagamentos = dadosPedido?.pagamentos || (dadosPedido?.pagamento ? [dadosPedido.pagamento] : []);

    if(!pagamentos || !pagamentos.length) return;

    for(let i = 0; i < pagamentos.length; i++){
      let dadospagamento = pagamentos[i];

      if(dadospagamento?.dadosCartao)
        await this.prepareDadosCartao(dadospagamento.dadosCartao);
    }
  }

  private async prepareDadosCartao(dadosCartao: any) {
    let tokenize: any = dadosCartao?.tokenize;

    if(!tokenize) return;

    if(tokenize.dataExpiracao && this.tokenExpirou(tokenize.dataExpiracao)){
      if(tokenize.provider === 'cellcoin'){
        const tokenizacao = await this.cellcoinTokenizacao.retokenize(tokenize);

        dadosCartao.token = tokenizacao.token;
        dadosCartao.cryptData = tokenizacao.cryptData;
        dadosCartao.ultimosNumeros = tokenizacao.ultimosNumeros || dadosCartao.ultimosNumeros;
      } else {
        let token = await this.tokenizeCartao(tokenize.card, tokenize.publicKey)

        if(token) dadosCartao.token = token;
      }
    }

    delete dadosCartao.tokenize
  }

  private tokenExpirou(dataExpiracao: any): boolean {
    const expiracaoNumero = Number(dataExpiracao);
    if(Number.isFinite(expiracaoNumero))
      return new Date().getTime() > expiracaoNumero;

    const expiracaoData = new Date(dataExpiracao).getTime();
    return Number.isFinite(expiracaoData) && new Date().getTime() > expiracaoData;
  }
}
